import React from 'react';

const AddDoctor = () => {
    return (
        <div>
            <h1>Add Doctors</h1>
        </div>
    );
};

export default AddDoctor;